/* Invite Craftly — redesign interactions: header, drawer, dropdowns, filters. No dependencies. */
(function () {
  'use strict';
  var header = document.querySelector('.rd-header');
  var pw = document.querySelector('.page-wrapper');
  if (header) {
    var onScroll = function () { var y = Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0); header.classList.toggle('is-scrolled', y > 8); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true }); if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
  }
  function closeDetails(except) {
    document.querySelectorAll('details[data-rd-pop][open]').forEach(function (d) { if (d !== except) d.removeAttribute('open'); });
  }
  document.addEventListener('click', function (e) { closeDetails(e.target.closest('details[data-rd-pop]')); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('details[data-rd-pop][open]');
    if (open) { open.removeAttribute('open'); var s = open.querySelector('summary'); if (s) s.focus(); }
  });
  var mq = window.matchMedia('(hover:hover) and (min-width:990px)');
  document.querySelectorAll('.rd-nav details').forEach(function (d) {
    var t;
    d.addEventListener('mouseenter', function () { if (!mq.matches) return; clearTimeout(t); closeDetails(d); d.setAttribute('open', ''); });
    d.addEventListener('mouseleave', function () { if (!mq.matches) return; t = setTimeout(function () { d.removeAttribute('open'); }, 160); });
  });
  var drawer = document.getElementById('rd-drawer');
  var opener = document.querySelector('[data-rd-open-drawer]');
  if (drawer && opener) {
    var panel = drawer.querySelector('.rd-drawer__panel');
    var lastFocus = null;
    var open = function () {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open'); drawer.removeAttribute('aria-hidden');
      opener.setAttribute('aria-expanded', 'true'); document.body.classList.add('rd-lock');
      setTimeout(function () { var c = drawer.querySelector('.rd-drawer__close'); if (c) c.focus(); }, 60);
    };
    var close = function () {
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
      opener.setAttribute('aria-expanded', 'false'); document.body.classList.remove('rd-lock');
      if (lastFocus) lastFocus.focus();
    };
    opener.addEventListener('click', open);
    drawer.addEventListener('click', function (e) { if (e.target.closest('[data-rd-close]') || e.target.closest('.rd-drawer__list a')) close(); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = panel.querySelectorAll('a[href],button,summary,input'); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
  document.querySelectorAll('[data-rd-filter]').forEach(function (bar) {
    var grid = document.getElementById(bar.getAttribute('data-rd-filter'));
    if (!grid) return;
    var cards = grid.querySelectorAll('[data-tags]');
    var empty = grid.parentElement.querySelector('[data-rd-empty]');
    var live = bar.parentElement.querySelector('[data-rd-live]');
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-value]'); if (!b) return;
      bar.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var v = b.getAttribute('data-value'), shown = 0;
      cards.forEach(function (c) {
        var ok = v === 'all' || (' ' + c.getAttribute('data-tags') + ' ').indexOf(' ' + v + ' ') > -1;
        c.hidden = !ok; if (ok) shown++;
      });
      if (empty) empty.hidden = shown > 0;
      if (live) live.textContent = shown + (shown === 1 ? ' design' : ' designs') + ' shown';
      try { history.replaceState(null, '', v === 'all' ? location.pathname : location.pathname + '?style=' + v); } catch (err) {}
    });
    var pre = new URLSearchParams(location.search).get('style');
    if (pre) { var btn = bar.querySelector('button[data-value="' + pre + '"]'); if (btn) btn.click(); }
  });
})();